import { computed, ref, watch } from 'vue';

export const DEFAULT_PAGE_SIZE = 100;

export const useTablePagination = (getTotal: () => number) => {
  const currentPage = ref(1);

  const pagination = computed(() => ({
    current: currentPage.value,
    pageSize: DEFAULT_PAGE_SIZE,
    total: getTotal(),
    hideOnSinglePage: true,
    showSizeChanger: false,
    position: ['bottomCenter'],
    onChange: (page: number) => {
      currentPage.value = page;
    }
  }));

  const resetPagination = () => {
    currentPage.value = 1;
  };

  watch(getTotal, (total) => {
    const totalPages = Math.max(1, Math.ceil(total / DEFAULT_PAGE_SIZE));

    if (currentPage.value > totalPages) {
      currentPage.value = totalPages;
    }
  });

  return {
    pagination,
    resetPagination
  };
};
